import { Link } from "react-router-dom";

/**
 * Category filter chips for the blog. `active` is a category slug or "all".
 * Navigates via URL query (?kategori=) so filters are shareable/indexable.
 */
export const CategoryChips = ({ categories = [], active = "all", total = 0 }) => {
  const items = [
    { slug: "all", name: "Tümü", count: total },
    ...categories.filter((c) => c.count > 0),
  ];
  return (
    <div
      role="tablist"
      aria-label="Blog kategorileri"
      data-testid="blog-category-filter"
      className="flex flex-wrap gap-2 justify-center"
    >
      {items.map((c) => {
        const isActive = active === c.slug;
        return (
          <Link
            key={c.slug}
            role="tab"
            aria-selected={isActive}
            to={c.slug === "all" ? "/blog" : `/blog?kategori=${c.slug}`}
            data-testid={`category-chip-${c.slug}`}
            className={
              "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm min-h-[44px] sm:min-h-0 " +
              "transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C8A24A] " +
              (isActive
                ? "bg-[#C8A24A] text-[#141517] border-[#C8A24A] font-semibold"
                : "bg-transparent text-[#EDE7DA] border-white/15 hover:border-[#C8A24A]/60 hover:text-white")
            }
          >
            {c.name}
            <span
              className={
                "text-xs rounded-full px-1.5 py-0.5 " +
                (isActive ? "bg-[#141517]/15 text-[#141517]" : "bg-white/5 text-[#9A9387]")
              }
            >
              {c.count}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default CategoryChips;
